import { forwardRef, memo, useMemo } from 'react'
import { useTheme } from '@mui/material/styles'

import { FontSize } from 'styles/theme/typography'

import { TextStyled } from './TextBase.styles'

import { TextBaseProps } from './index'

const TextBase = forwardRef<HTMLDivElement, TextBaseProps>(
  ({ text, asComp, children, fontSizeResponsive, ...rest }, ref) => {
    const theme = useTheme()
    const responsiveSize = useMemo(() => {
      if (fontSizeResponsive) {
        const remSize = theme.fontSizes[fontSizeResponsive as FontSize]
        return remSize ?? fontSizeResponsive
      }
      return undefined
    }, [fontSizeResponsive, theme])
    return (
      <TextStyled ref={ref} as={asComp} $responsiveSize={responsiveSize} {...rest}>
        {text ? <span>{text}</span> : children}
      </TextStyled>
    )
  },
)

export default memo(TextBase)
